var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { axiosInstance } from '@/api/realApi/_axios';
import { BASE_URL, CURRENT_PROTOCOL } from '@/api/realApi/_constants';
export function getSignature() {
    return __awaiter(this, arguments, void 0, function* (uploadPreset = 'avatars') {
        const { data } = yield axiosInstance.get(`${CURRENT_PROTOCOL}://${BASE_URL}/api/core/cloudinary/get_signature/`, {
            params: {
                upload_preset: uploadPreset,
            },
        });
        return data;
    });
}
export function uploadToCloudinary(fileOrUrl, sig, onUploadProgress) {
    return __awaiter(this, void 0, void 0, function* () {
        const form = new FormData();
        form.append('file', fileOrUrl);
        form.append('api_key', sig.apiKey);
        form.append('timestamp', String(sig.timestamp));
        form.append('signature', sig.signature);
        form.append('upload_preset', sig.uploadPreset);
        form.append('folder', sig.folder);
        const url = `https://api.cloudinary.com/v1_1/${sig.cloudName}/image/upload`;
        const response = yield axios.post(url, form, { onUploadProgress });
        const result = {
            asset_folder: response.data.asset_folder,
            asset_id: response.data.asset_id,
            bytes: response.data.bytes,
            created_at: response.data.created_at,
            display_name: response.data.display_name,
            format: response.data.format,
            original_filename: response.data.original_filename,
            public_id: response.data.public_id,
            secure_url: response.data.secure_url,
            url: response.data.url,
            height: response.data.height,
            width: response.data.width,
        };
        return result;
    });
}
